(function () {
    'use strict';

    angular.module('settings')
        .controller('TagUpdateController', TagUpdateController);

    TagUpdateController.$inject = ['$state', 'tagsDataSrvc', 'notificationSrvc', 'tagsMessagesConst', 'errorNotificationSrvc'];

    function TagUpdateController($state, tagsDataSrvc, notificationSrvc, tagsMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
        };
        self.tagData = {};

        self.updateTag = updateTag;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getTags();
        }

        function getTags() {
            return tagsDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                self.tagData = response;
                return response;
            });
        }

        function updateTag() {
            tagsDataSrvc.update({
                pk: self.tagData.pk
            }, self.tagData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", tagsMessagesConst.update);
                    $state.go('layout.tags.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
